export default [{
  path: 'features',
  name: 'workspace.features',
  meta: { title: '更新列表', icon: 'icon-info-outline', isAction: true }
}, {
  path: 'labeling',
  name: 'workspace.help',
  meta: { title: '帮助', icon: 'icon-question-mark-circle-outline', isAction: true }
}, {
  path: 'feedback',
  name: 'workspace.feedback',
  meta: { title: '反馈', icon: 'icon-email-outline', isAction: true }
}]
